<template>
  <div class="container">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="left" scope="col" colspan="2">{{ encabezado }}</th>
          <th class="left" scope="col" colspan="2">{{ Yeartwo }}</th>
          <th class="left" scope="col" colspan="2">{{ YearOne }}</th>
          <th class="left" scope="col" colspan="2">{{ varEntorno }}</th>
        </tr>
        <tr>
          <th class="left" scope="col" colspan="2"></th>
          <th scope="col">{{ numbe }}</th>
          <th scope="col">{{ por }}</th>
          <th scope="col">{{ numbe }}</th>
          <th scope="col">{{ por }}</th>
          <th scope="col">{{ numbe }}</th>
          <th scope="col">{{ por }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="left" scope="row" colspan="2">Lista 1</td>
          <td>
            <input
          :disabled="readOnly"
              class="input"
              v-model="distribuccionPersonalL.uno"
            />
          </td>
          <td>{{ toOne }}%</td>

          <td>
            <input
          :disabled="readOnly"
              v-model="distribuccionPersonalL.tres"
              class="input"
            />
          </td>
          <td>{{ toCinco }}%</td>

          <td>
            <input
          :disabled="readOnly"
              class="input"
              v-model="distribuccionPersonalL.cinco"
            />
          </td>

          <td>{{ toNueve }}%</td>
        </tr>

        <tr>
          <td class="left" scope="row" colspan="2">Lista 2</td>
          <td>
            <input
          :disabled="readOnly"
              class="input"
              v-model="distribuccionPersonalL.siete"
            />
          </td>

          <td>{{ toDos }}%</td>

          <td>
            <input
          :disabled="readOnly"
              v-model="distribuccionPersonalL.nueve"
              class="input"
            />
          </td>
          <td>{{ toSeis }}%</td>
          <td>
            <input
          :disabled="readOnly"
              class="input"
              v-model="distribuccionPersonalL.once"
            />
          </td>
          <td>{{ toDiez }}%</td>
        </tr>
        <tr>
          <td class="left" scope="row" colspan="2">Lista 3</td>
          <td>
            <input
          :disabled="readOnly"
              class="input"
              v-model="distribuccionPersonalL.trece"
            />
          </td>
          <td>{{ toTres }}%</td>

          <td>
            <input
          :disabled="readOnly"
              v-model="distribuccionPersonalL.quince"
              class="input"
            />
          </td>
          <td>{{ toSiete }}%</td>

          <td>
            <input
          :disabled="readOnly"
              class="input"
              v-model="distribuccionPersonalL.diecisiete"
            />
          </td>
          <td>{{ toOnce }}%</td>
        </tr>
        <tr>
          <td class="left" scope="row" colspan="2">Lista 4</td>
          <td>
            <input
          :disabled="readOnly"
              class="input"
              v-model="distribuccionPersonalL.diecinueve"
            />
          </td>
          <td>{{ toCuatro }}%</td>

          <td>
            <input
          :disabled="readOnly"
              v-model="distribuccionPersonalL.veintiuno"
              class="input"
            />
          </td>
          <td>{{ toOcho }}%</td>

          <td>
            <input
          :disabled="readOnly"
              class="input"
              v-model="distribuccionPersonalL.veintitres"
            />
          </td>
          <td>{{ toDoce }}%</td>
        </tr>
        <tr>
          <td class="left" scope="row" colspan="2">
            (a) Total de funcionarios evaluados
          </td>
          <td>
            {{ sumaUno }}
          </td>
          <td>
            100%
          </td>
          <td>
            {{ sumaDos }}
          </td>
          <td>
            100%
          </td>
          <td>
            {{ sumaTres }}
          </td>
          <td>
            100%
          </td>
        </tr>
        <tr>
          <td class="left" scope="row" colspan="2">
            (b) Total Dotación Efectiva año t
          </td>
          <td>{{ datsa.Contrata + datsa.Planta }}</td>

          <td></td>
          <td>{{ datsaUno.Contrata + datsaUno.Planta }}</td>

          <td></td>
          <td>{{ dasta.Contrata + dasta.Planta }}</td>

          <td></td>
        </tr>
        <tr>
          <td class="left" scope="row" colspan="2">
            Porcentaje de funcionarios evaluados (a/b)
          </td>
          <td>{{ porcentajeOne }}%</td>
          <td></td>
          <td>{{ porcentajeThree }}%</td>
          <td></td>
          <td>{{ porcentajeFive }}%</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import store from "../../../../../../store";
import axios from "axios";
export default {
  props: ["distribuccionPersonalL", "readOnly"],
  data() {
    return {
      varEntorno: `${process.env.VUE_APP_ANIO}`,
      YearOne: "",
      Yeartwo: "",
      YearThre: "",
      data: "1",
      dataTwo: "2",
      encabezado: "Listas",
      por: "%",
      numbe: "N°",
      treintaYsiete: "",
      treintaYnueve: "",
      cuarentaYuno: "",
      textOne: "Lista 1",
      textTwo: "Lista 2",
      textThree: "Lista 3",
      textFour: "Lista 4",
      textFive: "(a) Total de funcionarios evaluados",
      textSix: "(b) Total Dotación Efectiva año t",
      textSeven: "Porcentaje de funcionarios evaluados (a/b)",
      porcentajeOne: null,
      porcentajeThree: null,
      porcentajeFive: null,
      datsa: null,
      datsaUno: null,
      dasta: null,
      sumaUno: null,
      sumaDos: null,
      sumaTres: null,
      porUno: null,
      porDos: null,
      porTres: null,
      porCuatro: null,
      porCinco: null,
      porSeis: null,
      porSiete: null,
      porocho: null,
      porNueve: null,
      porDies: null,
      porOnce: null,
      porDoce: null,
      toOne: 0,
      toDos: 0,
      toTres: 0,
      toCuatro: 0,
      toCinco: 0,
      toSeis: 0,
      toSiete: 0,
      toOcho: 0,
      toNueve: 0,
      toDiez: 0,
      toOnce: 0,
      toDoce: 0,
    };
  },

  methods: {
    obtenerContenido: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=2&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data === undefined) {
          this.datos = true;
        }
        this.datsa =
          res.data[0].datos.indicadores[`${process.env.VUE_APP_ANIO}` - 2][0];
        this.datsaUno =
          res.data[0].datos.indicadores[`${process.env.VUE_APP_ANIO}` - 1][0];
        this.dasta =
          res.data[0].datos.indicadores[`${process.env.VUE_APP_ANIO}`][0];
        console.log("Esto es la data ", this.datsaUno);
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.YearOne = parseInt(this.varEntorno) - parseInt(this.data);
    this.Yeartwo = parseInt(this.varEntorno) - parseInt(this.dataTwo);
    this.obtenerContenido();
  },

  updated() {
    // sumaUno
    this.sumaUno =
      parseInt(this.distribuccionPersonalL.uno) +
      parseInt(this.distribuccionPersonalL.siete) +
      parseInt(this.distribuccionPersonalL.trece) +
      parseInt(this.distribuccionPersonalL.diecinueve);

    // sumaUno
    this.sumaDos =
      parseInt(this.distribuccionPersonalL.tres) +
      parseInt(this.distribuccionPersonalL.nueve) +
      parseInt(this.distribuccionPersonalL.quince) +
      parseInt(this.distribuccionPersonalL.veintiuno);
    //sumaTres

    this.sumaTres =
      parseInt(this.distribuccionPersonalL.cinco) +
      parseInt(this.distribuccionPersonalL.once) +
      parseInt(this.distribuccionPersonalL.diecisiete) +
      parseInt(this.distribuccionPersonalL.veintitres);
    //Uno

    this.treintaYsiete =
      (parseInt(this.sumaUno) /
        parseInt(this.datsa.Contrata + this.datsa.Planta)) *
      100;
    this.porcentajeOne = this.treintaYsiete.toFixed(2);
    //dos

    //tres
    this.treintaYnueve =
      (parseInt(this.sumaDos) /
        parseInt(this.datsaUno.Contrata + this.datsaUno.Planta)) *
      100;
    this.porcentajeThree = this.treintaYnueve.toFixed(2);
    //cuatro

    //five
    this.cuarentaYuno =
      (parseInt(this.sumaTres) /
        parseInt(this.dasta.Contrata + this.dasta.Planta)) *
      100;
    this.porcentajeFive = this.cuarentaYuno.toFixed(2);
    //six

    // porcentajEnTablas Fila Uno
    this.porUno =
      (parseInt(this.distribuccionPersonalL.uno) * 100) / this.sumaUno;
    this.porDos =
      (parseInt(this.distribuccionPersonalL.siete) * 100) / this.sumaUno;
    this.porTres =
      (parseInt(this.distribuccionPersonalL.trece) * 100) / this.sumaUno;
    this.porCuatro =
      (parseInt(this.distribuccionPersonalL.diecinueve) * 100) / this.sumaUno;

    // porcentajEnTablas Fila Dos

    this.porCinco =
      (parseInt(this.distribuccionPersonalL.tres) * 100) / this.sumaDos;
    this.porSeis =
      (parseInt(this.distribuccionPersonalL.nueve) * 100) / this.sumaDos;
    this.porSiete =
      (parseInt(this.distribuccionPersonalL.quince) * 100) / this.sumaDos;
    this.porocho =
      (parseInt(this.distribuccionPersonalL.veintiuno) * 100) / this.sumaDos;

    // porcentajEnTablas Fila tres
    this.porNueve =
      (parseInt(this.distribuccionPersonalL.cinco) * 100) / this.sumaTres;
    this.porDies =
      (parseInt(this.distribuccionPersonalL.once) * 100) / this.sumaTres;
    this.porOnce =
      (parseInt(this.distribuccionPersonalL.diecisiete) * 100) / this.sumaTres;
    this.porDoce =
      (parseInt(this.distribuccionPersonalL.veintitres) * 100) / this.sumaTres;

    this.toOne = this.porUno.toFixed(2);
    this.toDos = this.porDos.toFixed(2);
    this.toTres = this.porTres.toFixed(2);
    this.toCuatro = this.porCuatro.toFixed(2);
    this.toCinco = this.porCinco.toFixed(2);
    this.toSeis = this.porSeis.toFixed(2);
    this.toSiete = this.porSiete.toFixed(2);
    this.toOcho = this.porocho.toFixed(2);
    this.toNueve = this.porNueve.toFixed(2);
    this.toDiez = this.porDies.toFixed(2);
    this.toOnce = this.porOnce.toFixed(2);
    this.toDoce = this.porDoce.toFixed(2);

    // store.dispatch("rHumanos/actionsTable", {
    //   value: [
    //     {
    //       text: this.textOne,
    //       numeroAnioTwo: this.uno,
    //       porcentajeAnioTwo: this.dos,
    //       numeroAnioOne: this.tres,
    //       porcentajeAnioOne: this.cuatro,
    //       numeroAnio: this.cinco,
    //       porcentajeAnio: this.seis,
    //     },
    //     {
    //       text: this.textTwo,
    //       numeroAnioTwo: this.siete,
    //       porcentajeAnioTwo: this.ocho,
    //       numeroAnioOne: this.nueve,
    //       porcentajeAnioOne: this.diez,
    //       numeroAnio: this.once,
    //       porcentajeAnio: this.doce,
    //     },
    //     {
    //       text: this.textThree,
    //       numeroAnioTwo: this.trece,
    //       porcentajeAnioTwo: this.catorce,
    //       numeroAnioOne: this.quince,
    //       porcentajeAnioOne: this.dieciseis,
    //       numeroAnio: this.diecisiete,
    //       porcentajeAnio: this.dieciocho,
    //     },
    //     {
    //       text: this.textFour,
    //       numeroAnioTwo: this.diecinueve,
    //       porcentajeAnioTwo: this.veinte,
    //       numeroAnioOne: this.veintiuno,
    //       porcentajeAnioOne: this.veintidos,
    //       numeroAnio: this.veintitres,
    //       porcentajeAnio: this.veinticuatro,
    //     },
    //     {
    //       text: this.textFive,
    //       numeroAnioTwo: this.veinticinco,
    //       porcentajeAnioTwo: this.veintiseis,
    //       numeroAnioOne: this.veintisiete,
    //       porcentajeAnioOne: this.veintiocho,
    //       numeroAnio: this.veintinueve,
    //       porcentajeAnio: this.treinta,
    //     },
    //     {
    //       text: this.textSix,
    //       numeroAnioTwo: this.treintaYuno,
    //       porcentajeAnioTwo: this.treintaYdos,
    //       numeroAnioOne: this.treintaYtres,
    //       porcentajeAnioOne: this.treintaYcuatro,
    //       numeroAnio: this.treintaYcinco,
    //       porcentajeAnio: this.treintaYseis,
    //     },
    //       {
    //       text: this.textSeven,
    //       numeroAnioTwo: this.treintaYsiete,
    //       porcentajeAnioTwo: this.treintaYocho,
    //       numeroAnioOne: this.treintaYnueve,
    //       porcentajeAnioOne: this.cuarenta,
    //       numeroAnio: this.cuarentaYuno,
    //       porcentajeAnio: this.cuarentaYdos,
    //     },
    //   ],
    //   nameTable: "distribuccionPersonal",
    // });
  },
};
</script>

<style scoped>
th {
  text-align: center !important;
  font-size: 14px !important ;
}

td {
  text-align: left !important;
}
thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  width: 120%;
  padding: 5px;
}
.input {
  margin-right: 10px;
  width: 100px;
}

.left {
  text-align: left;
  font-weight: 800;
  color: #052333;
  font-size: 16px;
}
</style>
